import { useGA4React } from "ga-4-react";
import React from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import Layout from "./hoc/layout";

import { useDispatch } from "react-redux";
import Home from "./components/home";
import ChoosePath from "./components/investNowSteps/step1_choosePath";
import InvestmentSelect from "./components/investNowSteps/step2_investmentSelect";
import InvestSolution from "./components/investNowSteps/step3_investmentSolution";
import Details from "./components/investNowSteps/step4_details";
import FinaliseInvestment from "./components/investNowSteps/step5_finaliseInvestment";
import { useTitle } from "./providers/titleProvider";
import NotFound from "./components/ui/404";

import { hotjar } from "react-hotjar";
import { useSelector } from "react-redux";

hotjar.initialize(3494560, 6);

const ProtectedRoute = ({ element }) => {
  const location = useLocation();
  const { steps, active } = useSelector((state) => state.stepper.value);
  const activeStepUrl = steps?.[active]?.url || "/choose-path";

  // Only allow access if the current route matches the active step URL
  const isAllowedRoute = location.pathname === activeStepUrl;

  // Redirect any disallowed route to the active step URL
  if (!isAllowedRoute) {
    return <Navigate to={activeStepUrl} replace />;
  }

  return element;
};



const MainRoutes = () => {
  let location = useLocation();
  let ga4React = useGA4React();
  const { title } = useTitle();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (hotjar.initialized()) {
      hotjar.stateChange(location.pathname);
    }
  }, [location.pathname, ga4React]);

  return (
    <Layout>
      
        <Routes>
          <Route
            path="/choose-path"
            exact
            element={<ProtectedRoute element={<ChoosePath />} />}
          />
          <Route
            path="/investment-select"
            exact
            element={<ProtectedRoute element={<InvestmentSelect />} />}
          />
          <Route
            path="/investment-solution"
            exact
            element={<ProtectedRoute element={<InvestSolution />} />}
          />
          <Route
            path="/details"
            exact
            element={<ProtectedRoute element={<Details />} />}
          />
          <Route
            path="/finalise"
            exact
            element={<ProtectedRoute element={<FinaliseInvestment />} />}
          />
          <Route
            path="/"
            exact
            element={<ProtectedRoute element={<Home />} />}
          />
          {/* <Route path="/maintenance" exact element={<Maintenance />} /> */}

          {/* Catch-all route for 404 */}
<Route path="*" element={<NotFound />} />
        </Routes>
      
    </Layout>
  );
};

export default MainRoutes;
